<template>
  <div class="contents-wrap">
    <div class="box-titles">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <a @click="queryByPid(0)">{{$t('moduleTitles.root')}}</a>
        </a-breadcrumb-item>
        <a-breadcrumb-item v-for="(item,index) in folderDepthList" :key="index">
          <a @click="queryByPid(item.id)">{{item.name}}</a>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <a-button class="upload-btn" type="primary" @click="upload">
        {{$t('message.uploadBtn')}}<a-icon type="upload" />
      </a-button>
    </div>
    <div
      v-infinite-scroll="handleInfiniteOnLoad"
      class="demo-infinite-container"
      :infinite-scroll-disabled="busy"
      :infinite-scroll-distance="10"
    >
      <a-list :data-source="dataSourse" :grid="{ xs: 2, sm: 3, md: 4, lg: 6, xl: 6, xxl: 6 }">
        <a-list-item slot="renderItem" slot-scope="item">
          <div class="dir-wrapper" v-if="item.dir_id!=undefined">
            <div v-if="type==1">
              <a-card
                hoverable
                class="card-wrapper"
                :bodyStyle="{padding: 0}"
                @click="handleSelected(item)"
              >
                <div class="material-img-box">
                  <img class="material-img" alt="example" :src="item.url" />
                </div>
                <div class="material-span-box">
                  <span class="material-name" :title="item.name">{{item.name}}</span>
                </div>
              </a-card>
            </div>
            <div v-if="type==2">
              <a-card
                hoverable
                class="card-wrapper"
                :bodyStyle="{padding: 0}"
                @click="handleSelected(item)"
              >
                <div class="material-audio-box">
                  <!-- <audio controls="controls" class="material-audio" alt="example" :src="item.url" /> -->
                  <CAudio :audioUrl="item.url"></CAudio>
                </div>
                <div class="material-span-box">
                  <span class="material-name" :title="item.name">{{item.name}}</span>
                </div>
              </a-card>
              <!-- <span>{{item.name}}</span>
              <audio class="dir-title" controls="controls" :src="item.url">您的瀏覽器不支持 audio 標籤。</audio>-->
            </div>
            <div v-if="type==3">
              <a-card
                hoverable
                class="card-wrapper"
                :bodyStyle="{padding: 0}"
                @click="handleSelected(item)"
              >
                <div class="material-img-box">
                  <video class="material-video" controls="controls" alt="example" :src="item.url" />
                </div>
                <div class="material-span-box">
                  <span class="material-name" :title="item.name">{{item.name}}</span>
                </div>
              </a-card>
              <!-- <span>{{item.name}}</span>
              <video class="dir-title" controls="controls" :src="item.url">您的瀏覽器不支持 video 標籤。</video>-->
            </div>
          </div>
          <div class="dir-wrapper" v-else @click="queryByPid(item.id)">
            <a-card hoverable class="card-wrapper" :bodyStyle="bodyStyle">
              <!-- <img slot="cover" alt="example" :src="item.url" />
              <span style="font-size: 10px">{{item.name}}</span>-->
              <a-icon type="folder" theme="filled" style="color:#1790ff;font-size: 40px" />
              <a class="dir-title">{{item.name}}</a>
            </a-card>
          </div>
        </a-list-item>
        <div v-if="loading && !busy" class="demo-loading-container">
          <a-spin />
        </div>
      </a-list>
    </div>
  </div>
</template>

<script>
import { materialPageQuery, getFolderDepth } from "@/api/planeMaterial";
import infiniteScroll from "vue-infinite-scroll";
import CAudio from "@/components/CAudio";
import { mapGetters } from "vuex";


export default {
  name: "MaterialList",
  directives: { infiniteScroll },
  components: { CAudio },
  props: {
    type: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      busy: false,
      folderDepthList: [],
      dataSourse: [],
      searchParam: {
        current_page: 1,
        per_page: 30,
        pid: 0,
        name: "",
        type: this.type,
        order: {},
        status: 1,
      },
      bodyStyle: {
        padding:0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height:"100%"
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  beforeMount() {},
  mounted() {},
  watch: {},
  methods: {
    loadData() {
      if (this.loading == false){
        this.loading = true;
        materialPageQuery(this.searchParam)
          .then((res) => {
            this.loading = false;
            if (res.code === 1) {
              let lastPage = Math.ceil(
                res.data.total / this.searchParam.per_page
              );
              if (this.searchParam.current_page > lastPage) {
                this.busy = true;
                return false;
              }
              this.searchParam.current_page++;
              this.dataSourse = [...this.dataSourse, ...res.data.records];
            }
            this.busy = false;
          })
          .catch(() => {
            this.loading = false;
          });
        getFolderDepth({ id: this.searchParam.pid }).then((res) => {
          if (res.code === 1) {
            this.folderDepthList = res.data;
          }
        });
      }
    },
    resetLoad() {
      this.searchParam.current_page = 1;
      this.dataSourse = [];
      this.loadData();
    },
    queryByPid(pid) {
      this.searchParam.current_page = 1;
      this.searchParam.pid = pid;
      this.dataSourse = [];
      this.busy = false;
      this.loadData();
      this.$emit("dirChange", pid);
    },

    handleInfiniteOnLoad() {
      this.loadData();
    },
    handleSelected(item) {
      this.$emit("selected", item);
    },
    upload(){
      this.$emit("showUpload")
    }
  },
};
</script>

<style lang="less" scoped>
.dir-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /*height: 100px;*/
}

.card-wrapper {
  width: 100px;
  height: 130px;
}
.contents-wrap{
  padding-bottom: 30px;
  .upload-btn{
    position: absolute;
    top: -6px;
    right: 0;
    flex-shrink: 0;
  }
  .uploadBtn{
    background-color: #7101ad;
    border-color: #7101ad;
  }
  .box-titles{
    position: relative;
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
  }
}
.demo-infinite-container {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: auto;
  padding: 12px 24px;
  height: 350px;
}
.demo-loading-container {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
}
.material-img-box{
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f8f8f8;
}
.material-audio-box{
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}
.material-span-box{
  padding: 0 10px;
  box-sizing: border-box;
}
.material-img,.material-video{
  max-height: 100%;
  width: auto;
  max-width: 100%;
}
.material-name {
  display: inline-block;
  height: 30px;
  line-height: 30px;
  width: 100%;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
@media (max-width: 767px) {
  .demo-infinite-container {
    height: 300px;
  }
}
</style>
